// extracted by mini-css-extract-plugin
export default {"selectedCoinContainer":"SelectCoinInput_selectedCoinContainer__hCGxM"};